import { Toaster as Sonner, toast } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="system"
      position="top-right"
      duration={2000}
      className="toaster group"
      style={{ zIndex: 99999, top: 'calc(env(safe-area-inset-top, 0px) + 28px)' }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:border-border group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success:
            "!border-emerald-700 !bg-emerald-900/90 !text-emerald-100",
          error:
            "!border-red-700 !bg-red-900/90 !text-red-100",
          warning:
            "!border-amber-700 !bg-amber-900/90 !text-amber-100",
        },
      }}
      {...props}
    />
  )
}

export { Toaster, toast }
